<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Накладные') }}</h1>
    <div class="my-organization">
      <div class="blanks-pg bgw-pdg-20">
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <Menu :ooptId="$route.params.id"/>
          </div>
        </div>
        <div class="search-head">
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-label>{{ $t('Номер') }}</v-label>
              <v-text-field
                v-model="search.number"
                outlined
                dense
                clearable
              />
            </v-col>
          </v-row>
          <div class="search-action">
            <button
              class="btn btn-default green-grassy"
              @click="getList()"
            >
              {{ $t('Поиск') }}
            </button>
            <button
              class="btn btn-default gray"
              @click="search = {}, getList()"
            >
              {{ $t('Очистить') }}
            </button>
          </div>
        </div>
        <div class="search-body">
          <div class="table-overflow">
            <table class="table-full">
            <thead>
            <tr>
              <td>
                <div class="sort-flex">
                  {{ $t('Дата') }}
                  <a @click="sort('date')" class="sort-btn sort-blue">
                    <v-icon v-if="sortParams.field == 'date' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                    <v-icon v-else>arrow_drop_down</v-icon>
                  </a>
                </div>
              </td>
              <td>
                <div class="sort-flex">
                  №
                  <a @click="sort('number')" class="sort-btn sort-blue">
                    <v-icon v-if="sortParams.field == 'number' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                    <v-icon v-else>arrow_drop_down</v-icon>
                  </a>
                </div>
              </td>
              <td>
                <div class="sort-flex">
                  {{ $t('Статус') }}
                </div>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in invoiceBsos" :key="i">
              <td>{{ new Date(item.date) | dateFormat('DD.MM.YYYY') }}</td>
              <td>
                <a @click="printWord(item.id)">{{ $t('Накладная') }} № {{ item.number }}</a>
              </td>
              <td>{{ item.statusName }}</td>
            </tr>
            </tbody>
          </table>
          </div>
          <v-pagination
            v-model="page"
            :length="paginationData.pageCount"
            total-visible="10"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Menu from '@/components/bso/Menu'
import Bso from '@/model/bso'

export default {
  components: {
    Menu
  },
  data: () => ({
    page: 1,
    paginationData: {},
    breadcrumbs: [],
    invoiceBsos: [],
    approvedStatus: null,
    sortParams: {
      field: 'number',
      order: 'DESC'
    },
    search: {}
  }),
  watch: {
    page () {
      this.getList(false)
    }
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Bso.getInvoiceBsoDepartmentFilterFormData()
        .then((res) => {
          this.approvedStatus = res.data.approvedStatus
          this.getList()
        })
        .catch((err) => {
          this.setLoading(false)
        })
      this.generateBreadcrumbs()
    },
    getList (resetPage = true) {
      this.setLoading(true)
      if (resetPage) this.page = 1
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      this.search.oopt = this.$route.params.id
      this.search.status = this.approvedStatus
      Bso.listInvoiceBso(this.search)
        .then((res) => {
          this.invoiceBsos = res.data.items
          this.paginationData = res.data.paginationData
          this.setLoading(false)
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.getList()
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Накладные'),
          disabled: true
        }
      ]
    },
    // печать в ворд
    printWord (id) {
      this.setLoading(true)
      Bso.printInvoiceBso(id)
        .then(res => {
          if (res.status === 400) {
            this.$noty.warning(this.$i18n.t('Ошибка'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          } else {
            this.forceFileDownload(res)
          }
        })
        .catch(() => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })

      this.setLoading(false)
    },
    // генерация ссылки для скачивания ворд файла
    forceFileDownload (res) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'invoice_bso.docx')
      document.body.appendChild(link)
      link.click()
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
  .add-npa-row {
    margin-bottom: 0;
  }
</style>
